document.addEventListener("DOMContentLoaded", function(event) {
    // ---=== schedule modal - input number and "+" is allowed ===---
    function setInputFilter(textbox, inputFilter) {
        ["input", "keydown", "keyup", "mousedown", "mouseup", "select", "contextmenu", "drop", "focusout"].forEach(function(event) {
            textbox.addEventListener(event, function(e) {
                if (inputFilter(this.value)) {
                    if (["keydown","mousedown","focusout"].indexOf(e.type) >= 0){
                    }
                    this.oldValue = this.value;
                    this.oldSelectionStart = this.selectionStart;
                    this.oldSelectionEnd = this.selectionEnd;
                } else if (this.hasOwnProperty("oldValue")) {
                    this.value = this.oldValue;
                    this.setSelectionRange(this.oldSelectionStart, this.oldSelectionEnd);
                } else {
                    this.value = "";
                }
            });
        });
    }

    // init setInputFilter
    setInputFilter(document.getElementById("inputPhone"), function(value) {
        return /^[ 0-9+]*$/.test(value); // Allow digits and '.' only, using a RegExp
    }, "Only number is allowed");

    // add select inquiry placeholder
    const placeholderText = document.querySelector('.inquiryPlaceholder').textContent;
    const inquirySelectFirstOption = document.querySelector('#selectInquiryType > option:first-child');
    inquirySelectFirstOption.innerText = placeholderText;
});

// window.addEventListener('resize', function(event) {});